import React from 'react';
import PropTypes from 'prop-types';

function XButton({ active, activeColor, background, border, color }) {
  return (
    <>
      {background && (
        <path
          d="M636.66 322.457C649.858 322.457 660.557 311.758 660.557 298.56C660.557 285.363 649.858 274.664 636.66 274.664C623.463 274.664 612.764 285.363 612.764 298.56C612.764 311.758 623.463 322.457 636.66 322.457Z"
          fill={background}
        />
      )}
      <path
        d="M636.66 322.457C649.858 322.457 660.557 311.758 660.557 298.56C660.557 285.363 649.858 274.664 636.66 274.664C623.463 274.664 612.764 285.363 612.764 298.56C612.764 311.758 623.463 322.457 636.66 322.457Z"
        fill={activeColor}
        fillOpacity={active ? 1 : 0}
      />
      <path
        d="M624.994 283.795L622.57 286.215C626.589 290.231 630.603 294.248 634.622 298.265C630.603 302.281 626.589 306.298 622.57 310.315L624.994 312.735C629.008 308.718 633.027 304.702 637.04 300.685C641.06 304.702 645.073 308.718 649.092 312.735L651.511 310.315C647.491 306.298 643.478 302.281 639.464 298.265C643.478 294.248 647.497 290.231 651.511 286.215L649.092 283.795C645.079 287.811 641.06 291.828 637.04 295.845C633.027 291.828 629.008 287.811 624.994 283.795Z"
        fill={color}
      />
      <path
        d="M636.896 273.455C623.226 273.455 612.102 284.58 612.102 298.252C612.102 311.923 623.226 323.049 636.896 323.049C650.572 323.049 661.697 311.923 661.697 298.252C661.697 284.58 650.572 273.455 636.896 273.455ZM636.896 277.338C648.47 277.338 657.804 286.679 657.804 298.252C657.804 309.825 648.47 319.165 636.896 319.165C625.322 319.165 615.983 309.825 615.983 298.252C615.983 286.679 625.322 277.338 636.896 277.338Z"
        fill={border}
      />
    </>
  );
}

XButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  background: PropTypes.string,
  border: PropTypes.string,
  color: PropTypes.string,
};

XButton.defaultProps = {
  active: false,
  activeColor: '#FF0000',
  background: null,
  border: '#6F727C',
  color: '#464A56',
};

export default XButton;
